import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {environment} from "../../environments/environment";
import {SharedPreference} from '../shared-preference/shared-perference';
import {dashboardUrl} from '../inventory/route';

@Injectable({
  providedIn: 'root'
})
export class HomePageGuardService implements CanActivate{

  constructor(
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(SharedPreference.isShowingMenu || SharedPreference.getUser()){
      this.router.navigate([dashboardUrl]);
    }

    return environment.isEnableHomePage;
  }
}
